import { MemberDirectoryPage } from '@/imports/ui/pages/user/MemberDirectoryPage';
import { RouteRestrictions } from '@/utilities';
import { restrictedRoute } from '@/utilities/restrictedRoute';

export default restrictedRoute(MemberDirectoryPage, {
  requiresEvery: [RouteRestrictions.MEMBER_DIRECTORY_ACCESS],
});
